"use strict";
/**
 * Inventory Report Responses
 *
 * Response types for inventory report endpoints.
 *
 * @example POST /api/inventory/reports/generate
 * @example GET /api/inventory/reports/periods
 */
Object.defineProperty(exports, "__esModule", { value: true });
